import React, { Component } from 'react';
import { Button } from 'reactstrap';
import {BOARD_TYPE} from './Constans'
import BoardView from './BoardView';
import Game from './core/Game';
import {DraughtsTypes8x8 } from './utils/symbols';


export default class VariantViewer extends Component {

    constructor(props) {
        super(props);
       
        switch (parseInt(props.boardType, 10)) {
            case BOARD_TYPE.B64:
                this.game = new Game(8, this.props.draughtsType);
                this.boardType = BOARD_TYPE.B64;
            break;
            case BOARD_TYPE.B100:
                this.game = new Game(10);
                this.boardType = BOARD_TYPE.B100;
            break;
            case BOARD_TYPE.B144:
                this.game = new Game(12);
                this.boardType = BOARD_TYPE.B144;
            break;
            default:
                this.game = new Game(10);
                this.boardType = BOARD_TYPE.B100;
            break;
        }

        this.firstMove = this.firstMove.bind(this);
        this.nextMove = this.nextMove.bind(this);
        this.prevMove = this.prevMove.bind(this);
        this.lastMove = this.lastMove.bind(this);
        this.onSquareClick = this.onSquareClick.bind(this);
       
        this.game.parsePDN(this.props.pdn);
        this.startFenPdnTag = this.game.getCurrentFenPdnTag();
        this.state = {
            currentPositionData: this.game.getCurrentPosition(),
            selectedSquares: this.game.getEmptySelectedSquare()
        }
    }

    flipBoard() {
        let white = !this.state.whiteOnTop;
        this.setState({
            whiteOnTop: white
        })
    }

    firstMove() {
        if (this.game.hasPrev()) {
            this.game.start();
            this.setState({
                currentPositionData: this.game.getCurrentPosition(),
                currentMove: this.game.getCurrentMove(),
                selectedSquares: this.game.getEmptySelectedSquare()
            })
        }
    }

    lastMove() {
        if (this.game.hasNext()) {
            this.game.end();
            this.setState({
                currentPositionData: this.game.getCurrentPosition(),
                currentMove: this.game.getCurrentMove(),
                selectedSquares: this.game.getEmptySelectedSquare()
            })
        }
    }

    prevMove() {
        if (this.game.hasPrev()) {
            this.game.prev();
            this.setState({
                currentPositionData: this.game.getCurrentPosition(),
                currentMove: this.game.getCurrentMove(),
                selectedSquares: this.game.getEmptySelectedSquare()
            })
        }
    }

    nextMove() {
        if (this.game.hasNext()) {
            this.game.next();
            this.setState({
                currentPositionData: this.game.getCurrentPosition(),
                currentMove: this.game.getCurrentMove(),
                selectedSquares: this.game.getEmptySelectedSquare()
            })
        }
    }
    
  
    _addNewMoveBySelected(selectedSquare, squareId) {

        this.game.removeRestMoves();
        if (selectedSquare.isDestinationSquare) {
            this.game.addMove(squareId, selectedSquare.selectedSquare);
        } else {
            this.game.addMove(selectedSquare.selectedSquare, squareId);
        }
        this.nextMove();
        const pdn = this.startFenPdnTag + "\n" + this.game.getPDNNotation();
        this.props.onChangeVariantData(this.props.postId, pdn);
    }

    onSquareClick(squareId) {
        
        if (!this.props.movesEdit) return;
        if (this.state.selectedSquares.validMoves.length > 0) {
            if (this.state.selectedSquares.validMoves.indexOf(squareId) > -1) {
                this._addNewMoveBySelected(this.state.selectedSquares, squareId);
                return;
            }
        } 
        
        let selSquares = {}
        if (this.game.isEmpty(squareId)) {
            selSquares = this.game.getValidMovesGetSourceFields(squareId);
        } else {
            selSquares = this.game.getValidMoves(squareId);
        }

        if (selSquares.validMoves.length === 1) {
            this._addNewMoveBySelected(selSquares, selSquares.validMoves[0]);
            return;
        }

        this.setState({
            selectedSquares: selSquares,
        })
    }


    render() {
        const props = this.props;
        const state = this.state;
        const sizeComp = parseInt(props.size, 10);
      
        return (
            <div>
                <div style={{marginBottom:"5px"}}>
                <BoardView size={sizeComp - 40} 
                    whiteOnTop={state.whiteOnTop} 
                    type={this.boardType} 
                    currentPositionData={state.currentPositionData}
                    clickSquareHandler = {this.onSquareClick} 
                    selectedSquares = {state.selectedSquares} 
                    draughtsType={this.props.draughtsType}
                    >
                </BoardView>
                </div>
                {this.props.navigateButtons &&
                <div>
                <Button size="sm" onClick={() => this.firstMove()}><span className="glyphicon glyphicon-fast-backward"></span></Button>&nbsp;
                <Button size="sm" onClick={() => this.prevMove()}><span className="glyphicon glyphicon-backward"></span></Button>&nbsp;
                <Button size="sm" onClick={() => this.nextMove()}><span className="glyphicon glyphicon-forward"></span></Button>&nbsp;
                <Button size="sm" onClick={() => this.lastMove()}><span className="glyphicon glyphicon-fast-forward"></span></Button>&nbsp;
                </div>}
                
            </div>
        )
    }
    
} 


// WEBPACK FOOTER //
// ./src/board/VariantViewer.js